<template>
  <div class="notifications">
    <button type="button" class="exit-button" @click="close()"><rp-sprite class="exit-icon" name="close"/></button>
    <div class="title">
      Notifications
    </div>
    <hr>
    <div class="notification-panel">
      <div v-html="displayedNotification" />
    </div>
    <hr>
    <div class="button-container">
      <rp-button
        class="next-button" 
        type="primary"
        @click="nextOrCloseNotification">
          {{ 'dismiss' | uppercase }}
      </rp-button>
    </div>
  </div>
</template>

<script>
import Sprite from './Sprite'
import Button from './inputs/Button'
import {mapGetters, mapMutations} from 'vuex'

export default {
  props: {
    value: Array,
    preview: Boolean
  },

  components: {
    'rp-sprite': Sprite,
    'rp-button': Button
  },

  computed: {
    isLastNotification() {
      const notificationSum = this.value.length
      const compareIndex = this.notificationIndex + 1
      
      return notificationSum === compareIndex
    },

    displayedNotification() {
      return this.value[this.notificationIndex].content
    }
  },

  methods: {
    ...mapMutations(['removeFromNotifications', 'removeAllNotifications']),

    close() {
      if(this.preview) {
        this.$emit('exit')
        return
      }
      
      this.removeAllNotifications()
    },

    nextOrCloseNotification() {
      if(this.preview) {
        this.$emit('exit')
        return
      }

      this.removeFromNotifications(this.value[this.notificationIndex])
    },
  },

  data() {
    return {
      notificationIndex: 0
    }
  },

  filters: {
    uppercase(text) {
      return text.toUpperCase();
    }
  }
}
</script>


<style lang="sass" scoped>
@import '../../styles/main.sass'


.notifications
  display: flex
  flex-direction: column
  margin: 0 20px
  padding: 30px
  position: relative
  min-width: 30vw
  max-width: 60vw
  max-height: 80vh
  background: $color-panel-bg
  transition: opacity 0.2s
  border-radius: 5px

  @media screen and (max-width: $screen-small)
    max-width: 90vw
    max-height: 90vh

  .exit-button
    position: absolute
    right: 5px
    top: 5px
    padding: 10px
    border: 0
    background-color: white

    .exit-icon
      width: 24px
      height: 24px
      fill: grey

  .title
    color: #0C3717
    font-size: 1.8rem
    font-weight: 400
    margin-bottom: 20px
  
  hr
    margin: 0 -30px
    background-color: #d4d4d4
    height: 1px
    border: 0

  .notification-panel
    overflow-y: auto
    padding: 3rem 1rem
    @media screen and (max-width: $screen-small)
      padding: 5px 0


  .button-container
    display: flex
    flex-direction: row-reverse
    justify-content: space-between
    margin-top: 30px

    button
      padding: 12px 50px
      height: auto

      @media screen and (max-width: $screen-small)
        padding: 12px 20px

      &.next-button
        color: white

      &.delete-button
        color: $color-error
        border-color: $color-error
        border-width: 1px

</style>


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Notification.vue